import DoctorLayout from "../../Layout/DoctorLayout";
import PatientTypeContextProvider from "../../Layout/DoctorLayout/PatientTypeContextProvider";
import OPLandingLayout from "../OPLandingLayout/OPLandingLayout";
import OpPatientHeader from "../OpPatientHeader";
import React from "react";

const CommonOPView = () => {
  return (
    <PatientTypeContextProvider>

      <DoctorLayout header={false}>
        <OpPatientHeader />
        <OPLandingLayout />
      </DoctorLayout>


    </PatientTypeContextProvider>
  );
};

export default CommonOPView;
